"use strict";
/**
 * Where Electric Era's own web apps live, per environment.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.incidentPageUrl = exports.grafanaUrl = exports.commandConsoleUrl = exports.isProdEnvironment = void 0;
/** The Command Console, where operators work. */
const COMMAND_CONSOLE_URLS = {
    prod: "https://cmd-console.app.electricera.tech",
    dev: "https://cmd-console.dev.electricera.tech",
};
/** Grafana, where dashboards and logs live. */
const GRAFANA_URLS = {
    prod: "https://grafana.noc.electricera.tech",
    dev: "https://grafana.dev.electricera.tech",
};
/**
 * Whether `environment` names production. Only the exact string `PROD` counts.
 *
 * Unset resolves to dev, the safe direction: a prod link in a dev ticket would
 * send an engineer to operate on real sites believing they are not.
 *
 * @param environment - The raw `ENVIRONMENT` value, generally
 * `this.configService.get<string>("ENVIRONMENT")`. Compared
 * case-insensitively after trimming; anything but `PROD` (including
 * null/undefined) means dev.
 */
function isProdEnvironment(environment) {
    return environment?.trim().toUpperCase() === "PROD";
}
exports.isProdEnvironment = isProdEnvironment;
/**
 * The Command Console's base URL, with no trailing slash.
 *
 * @param environment - Generally `this.configService.get<string>("ENVIRONMENT")`.
 * See {@link isProdEnvironment} for how it's interpreted.
 */
function commandConsoleUrl(environment) {
    return isProdEnvironment(environment)
        ? COMMAND_CONSOLE_URLS.prod
        : COMMAND_CONSOLE_URLS.dev;
}
exports.commandConsoleUrl = commandConsoleUrl;
/**
 * Grafana's base URL, with no trailing slash.
 *
 * @param environment - Generally `this.configService.get<string>("ENVIRONMENT")`.
 * See {@link isProdEnvironment} for how it's interpreted.
 */
function grafanaUrl(environment) {
    return isProdEnvironment(environment) ? GRAFANA_URLS.prod : GRAFANA_URLS.dev;
}
exports.grafanaUrl = grafanaUrl;
/**
 * The Command Console page for one incident (`/incident/:uid`).
 *
 * @param uid - The incident's UID, as stored on `Incident.uid`.
 * @param environment - Generally `this.configService.get<string>("ENVIRONMENT")`.
 * See {@link isProdEnvironment} for how it's interpreted.
 */
function incidentPageUrl(uid, environment) {
    return `${commandConsoleUrl(environment)}/incident/${uid}`;
}
exports.incidentPageUrl = incidentPageUrl;
